import { SignupLoginService } from "src/app/services/signupLogin.service";
import { Injectable } from "@angular/core";
import {
  billingPayload,
  Billing,
  PaystackRefund,
} from "src/app/models/license.model";
import { StandaloneSignupService } from "./standalone-signup.service";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { GeneralService } from "src/app/services/general.service";
import { AuthService } from "src/app/auth/auth.service";
import { BehaviorSubject } from "rxjs";
import { finalize } from "rxjs/operators";
import { Endpoints } from "src/app/shared/config/endpoints";

declare var PaystackPop: any;

@Injectable({
  providedIn: "root",
})
export class BillingService {
  private billingLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  public closeModal: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  billingLoading$ = this.billingLoading.asObservable();

  constructor(
    private signUpService: StandaloneSignupService,
    private http: HttpClient,
    private router: Router,
    private signUpSrv: SignupLoginService,
    private gs: GeneralService,
    private auth: AuthService,
    private endPoints: Endpoints
  ) { }

  public get billingLoadingValue() {
    return this.billingLoading.value;
  }

  setBillingLoadingValue(value: boolean) {
    this.billingLoading.next(value);
  }

  /**
   * paystack payment integration for billing
   */
  payWithPaystack(payload: billingPayload, returnUrl?: string) {
    this.signUpService.loadingSubject.next(true);

    let scope = this;
    var handler = PaystackPop.setup({
      key: environment.paystackKey,
      email: payload.email,
      amount: payload.amount * 100,
      currency: payload.currency,
      ref: "" + Math.floor(Math.random() * 1000000000 + 1),
      metadata: payload.metadata,
      callback: function (response) {
        scope.paystackCallback(
          payload,
          response,
          scope,
          returnUrl ? returnUrl : null
        );
      },
      onClose: function () {
        scope.paystackClosed();
        // alert("window closed");
      },
    });
    handler.openIframe();
  }

  /**
   * callback when the dialog box is closed
   */
  paystackClosed() {
    // alert("window closed");
    location.reload();
  }

  /**
   * callback to when payment is completed
   */
  paystackCallback(payload: billingPayload, response, scope, returnUrl?) {
    if (response.status === "success") {
      // scope.gs.showSpinner.next(true);
      //success
      this.http
        .get(
          `https://api.paystack.co/transaction/verify/${response.reference}`,
          {
            headers: new HttpHeaders({
              Authorization:
                "Bearer sk_test_72248eda05faefef1c111f5f82a8373c53ba85c5",
            }),
          }
        )
        .subscribe((resp: any) => {
          if (resp.status === true) {
            //make billing call
            let org = JSON.parse(localStorage.getItem("organization"));

            if (!org) org = this.auth.getCurrentUser.organization;

            let d = new Date();

            if (payload.monthly) {
              d = new Date(d.setMonth(d.getMonth() + 1));
            } else {
              d = new Date(d.setMonth(d.getMonth() + 12));
            }

            let billing = new Billing(
              payload.amount,
              payload.currency,
              payload.license.descrip,
              d.toISOString(),
              payload.license.name,
              String(payload.license.id),
              payload.monthly ? "Monthly" : "Annually",
              "Auto",
              "",
              0,
              org.email,
              org.id,
              org.name,
              payload.amount,
              "Regular",
              JSON.stringify(response),
              payload.monthly ? "month" : "year",
              new Date().toISOString(),
              true
            );

            //create the user card info
            this.createCard(resp.data.authorization);

            this.createBilling(billing, returnUrl ? returnUrl : null);
          }
        });
    } else {
      //error
      Swal.fire({
        type: "error",
        title: `Something went wrong`,
        text: `Please try again`,
      });
    }
  }

  /**
   * charge authorizatoin
   * @param
   */
  chargeAuthorization(data: billingPayload) {
    this.billingLoading.next(true);

    let payload = {
      authorization_code: data.authorization_code,
      email: data.email,
      amount: data.amount * 100,
      currency: data.currency,
      ref: "" + Math.floor(Math.random() * 1000000000 + 1),
      metadata: data.metadata,
    };

    //make billing call
    let org = this.auth.getCurrentUser.organization;

    let d = new Date();

    if (data.monthly) {
      d = new Date(d.setMonth(d.getMonth() + 1));
    } else {
      d = new Date(d.setMonth(d.getMonth() + 12));
    }

    let billing = new Billing(
      data.monthly ? data.license.monthlyPrice : data.license.annuallyPrice,
      data.currency,
      data.license.descrip,
      d.toISOString(),
      data.license.name,
      String(data.license.id),
      data.monthly ? "Monthly" : "Annually",
      "",
      "",
      0,
      org.email,
      String(org.id),
      org.name,
      data.amount,
      "Regular",
      "",
      data.monthly ? "month" : "year",
      new Date().toISOString(),
      true
    );

    let returnUrl = "/settings/billing";

    this.http
      .post(
        `https://api.paystack.co/transaction/charge_authorization`,
        payload,
        {
          headers: new HttpHeaders({
            Authorization:
              "Bearer sk_test_72248eda05faefef1c111f5f82a8373c53ba85c5",
          }),
        }
      )
      .subscribe(
        (resp: any) => {
          if (resp.status === true) {
            billing.paymentData = JSON.stringify({
              reference: resp.data.reference,
            });
            this.createBilling(billing, returnUrl);
          }
        },
        (error) => {
          billing.paymentData = JSON.stringify(error.error);
          this.createBilling(billing, returnUrl);
        }
      );
  }

  createBilling(billing: Billing, urlPath?: string) {
    this.signUpService.createBilling(billing).subscribe((resp: any) => {
      if (resp) {
        let userContext = JSON.parse(localStorage.getItem("currentUser"));
        userContext.organization = {
          ...userContext.organization,
          plan: billing.license,
          planStatus: "Running",
        };
        this.auth.updateUserAndOrg(userContext);
        localStorage.removeItem("organization");
        //success
        Swal.fire({
          type: "success",
          title: "Subscription Successful",
          text: "Thank you",
          showConfirmButton: true,
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Great!',
        }).then((result) => {
          this.successBillCreation(userContext);
          // if (result.value) {
          //   this.router.navigateByUrl("/dashboard");
          //   window.location.href = `${environment.notchAppURL}${urlPath ? urlPath : "/dashboard"}`;
          // }
        });
      }
    }, (error) => {
      let message = error && error.error ? error.error.message : error.message;
      Swal.fire({
        type: "error",
        title: "Oops...",
        text: message,
      }).then((result) => {
        if (result.value) {
          // this.router.navigateByUrl("/dashboard");
          // window.location.href = `${environment.notchAppURL}/dashboard`;
        }
      });
    }
    );
  }

  private successBillCreation(data) {
    this.signUpSrv.successLoginActionSrv(data).subscribe((resp) => {
      this.auth.storeUser({ ...data, ...resp });
      this.gs.fetchCurrency.next("");
      this.router.navigate(["/dashboard"]).then(() => window.location.reload());
    }, err => {
      this.gs.sweetAlertError(this.gs.getErrMsg(err));
    })
  }

  createCard(payload: any) {
    let userContext = JSON.parse(localStorage.getItem("currentUser"));

    payload = {
      ...payload,
      authorizationCode: payload.authorization_code,
      lastFour: payload.last4,
      account_name: "",
      receiver_bank_account_number: "",
      receiver_bank: "",
      userID: userContext.user.id,
      accountName: "",
      receiverBankAccountNumber: "",
      receiverBank: "",
      expMonth: payload.exp_month,
      expYear: payload.exp_year,
      countryCode: payload.country_code,
      type: payload.card_type,
      orgID: userContext.organization.id,
    };
    this.signUpService.createCard(payload).subscribe((resp) => {
      if (resp) {
        //success
        this.closeModal.next(true);
      } else {
        //error
      }
    });
  }

  initializeTransaction() {
    this.billingLoading.next(true);

    let payload = {
      reference: "" + Math.floor(Math.random() * 1000000000 + 1),
      amount: 100,
      email: this.auth.getCurrentUser.organization.email,
    };
    return this.http
      .post(`https://api.paystack.co/transaction/initialize/`, payload, {
        headers: new HttpHeaders({
          Authorization:
            "Bearer sk_test_72248eda05faefef1c111f5f82a8373c53ba85c5",
        }),
      })
      .pipe(
        finalize(() => {
          this.billingLoading.next(false);
        })
      );
  }

  verifyPaystackPayment(response) {
    this.billingLoading.next(true);
    return this.http
      .get(`https://api.paystack.co/transaction/verify/${response.reference}`, {
        headers: new HttpHeaders({
          Authorization:
            "Bearer sk_test_72248eda05faefef1c111f5f82a8373c53ba85c5",
        }),
      })
      .pipe(
        finalize(() => {
          this.billingLoading.next(false);
        })
      );
  }

  paystackRefund(payload: PaystackRefund) {
    this.billingLoading.next(true);
    this.http
      .post(`https://api.paystack.co/refund`, payload, {
        headers: new HttpHeaders({
          Authorization:
            "Bearer sk_test_72248eda05faefef1c111f5f82a8373c53ba85c5",
        }),
      })
      .pipe(
        finalize(() => {
          this.billingLoading.next(true);
        })
      )
      .subscribe((resp) => { });
  }

  deleteBillingCard(billingID: number) {
    this.billingLoading.next(true);
    const headers = this.gs.getCommandCenterHeaders();
    return this.http
      .post(
        `${this.endPoints.adminserviceUrl}/${billingID}/deleteBillingPayment`,
        {},
        {headers}
      )
      .pipe(
        finalize(() => {
          this.billingLoading.next(false);
        })
      );
  }

  getStorageUsage(orgID: string) {
    return this.http
      .get(
        `${this.endPoints.salesServiceUrl}/${orgID}/getOrganizationStorage`
      )
      .pipe(finalize(() => { }));
  }

  getLicenseUpgradeDetails(id, orgID, currency) {
    const headers = this.gs.getCommandCenterHeaders();
    return this.http
      .get(
        `${this.endPoints.adminserviceUrl}/getLicenseUpgradeDetails/${orgID}/${id}/${currency}`,{headers}
      )
      .pipe(finalize(() => { }));
  }

  getTenantBalance() {
    this.billingLoading.next(true);
    const headers = this.gs.getCommandCenterHeaders();
    return this.http
      .get(
        `${this.endPoints.adminserviceUrl}/${this.auth.getCurrentUser.organization.id}/getTenantBalance`,{headers}
      )
      .pipe(
        finalize(() => {
          this.billingLoading.next(false);
        })
      );
  }

  getBillingInvoice(billing: Billing) {
    this.billingLoading.next(true);
    let products = []
    const data = billing.payments
    if (data) {
      data.forEach(element => {
        const v = {
          itemName: billing.license,
          description: element.details,
          amount: element.amount.toFixed(2),
        }
        products.push(v);
      });
    }
    if (data.length === 0) {
      const v = {
        itemName: billing.license,
        description: billing.descrip,
        amount: billing.amount.toFixed(2),
      }
      products.push(v);
    }
    const payload = {
      organisation: {
        name: "ATB Techsoft Solutions",
        mobile: "(800) 555-1234",
        email: "sales@atbtechsoft.com",
        website: "wwww.atbtechsoft.com",
      },
      invoice: {
        accounts: [
          {
            bank: "Igbogbo",
            number: 7896665342,
            name: "To remove",
          },
        ],
        id: `INV-LIC-${billing.id}`,
        clientId: this.auth.getCurrentUser.organization.id,
        clientName: this.auth.getCurrentUser.organization.name,
        products: products,
        currency: billing.currency === "NGN" ? "₦" : billing.currency,
        createdOn: new Date(billing.createdDate).getTime(),
        refNumber: "#76810577",
        paymentDueDate: new Date(billing.exprDate).getTime(),
        taxAmount: billing.taxAmount,
        totalCost: billing.amount.toFixed(2),
        balanceDue: 0,
      },
      templateId: 999,
      type: "invoice",
      client: {
        email: this.auth.getCurrentUser.organization.email,
        invoiceTemplateId: 2,
        id: this.auth.getCurrentUser.organization.id,
        name: this.auth.getCurrentUser.organization.name,
        orgId: this.auth.getCurrentUser.organization.id,
      },
      userId: this.auth.getCurrentUser.user.id,
    };
    // debugger;
    return this.http.post(`${environment.notchPDFConverter}`, payload).pipe(
      finalize(() => {
        this.billingLoading.next(false);
      })
    );
  }

  verifyLicensePayment({ orgId, reference }) {
    const headers = this.gs.getCommandCenterHeaders();
    return this.http.get<any>(`${this.endPoints.adminserviceUrl}/${orgId}/getTenantBillings`,{headers});
    // return this.http.get<any>(`${this.endPoints.adminserviceUrl}/checkReference/${reference}`);
  }
  startTrial(payload: any) {
    const headers = this.gs.getCommandCenterHeaders();
    return this.http.post(`${this.endPoints.adminserviceUrl}/startTrial`, payload,{headers})
  }
  extendTrail(tenantID: any,licenseID: any) {
    const headers = this.gs.getCommandCenterHeaders();
    return this.http.get(`${this.endPoints.adminserviceUrl}/trialExtention/${tenantID}/${licenseID}`,{headers})
  }
  comfirmPaystackPayment(reference) {
    const headers = this.gs.getCommandCenterHeaders();
    return this.http.get<any>(`${this.endPoints.adminserviceUrl}/checkReference/${reference}`,{headers});
  }
  getAllUsersInOrganization(orgId) {
    return this.http.get<any>(`${this.endPoints.signUpEndpoint}/getOrganizationPersons/${orgId}/${2}`);
  }

  verifyPaystackTransactionRef(reference){
    const headers = this.gs.getCommandCenterHeaders();
    return this.http.get<any>(`${this.endPoints.adminserviceUrl}/checkReference/${reference}`,{headers})

  }
}
